import React from "react";

import { LinearProgress } from "@material-ui/core";

import useStyles from "./styles";

interface ProgressColumnCellProps {
  partial: number;
  total: number;
  color?: "primary" | "secondary";
}

export const normalizeProgressBar = (value: number, max: number): number => {
  return max > 0 ? Math.floor((value * 100) / max) : 0;
};

const ProgressColumnCell: React.FC<ProgressColumnCellProps> = ({
  partial,
  total,
  color = "primary",
}) => {
  const classes = useStyles();
  const percentage = normalizeProgressBar(partial, total);

  return (
    <div className={classes.root}>
      <div className={classes.linearProgressContainer}>
        <LinearProgress
          className={classes.linearProgress}
          classes={{
            colorPrimary: classes.linearProgressColorPrimary,
            barColorPrimary: classes.linearProgressBarColorPrimary,
            barColorSecondary: classes.linearProgressBarColorSecondary,
          }}
          color={color}
          variant="determinate"
          value={percentage}
        />
      </div>
    </div>
  );
};

export default ProgressColumnCell;
